export const edyOrganizationsTranslations = {
  lv: {
    title: 'Prakses vietas',
    search: 'Meklēt pēc nosaukuma vai reģistrācijas numura',
    empty: 'Prakses vietas nav atrastas',
    columns: {
      name: 'Nosaukums',
      regNo: 'Reģ. nr.',
      address: 'Adrese',
      subscription: 'Plāns',
      planEnd: 'Plāna beigas',
      userCount: 'Lietotāji',
      activeInterns: 'Aktīvie praktikanti',
      branch: 'Filiāle',
      actions: 'Darbības',
    },
    plans: {
      Business: 'Bizness',
      Free: 'Bezmaksas',
      None: 'Nav',
    },
    actions: {
      edit: 'Labot',
    },
    edit: {
      title: 'Labot uzņēmumu',
      save: 'Saglabāt',
    },
    fields: {
      isPrivatePerson: 'Privātpersona',
      name: 'Nosaukums',
      firstName: 'Vārds',
      lastname: 'Uzvārds',
      email: 'E-pasts',
      phone: 'Tālrunis',
      webSite: 'Mājaslapa (nav obligāta)',
      address: 'Adrese',
      regNo: 'Reģistrācijas numurs',
      vatNo: 'PVN numurs',
    },
    validation: {
      required: 'Lauks nav aizpildīts',
      email: 'Nederīgs e-pasts',
    },
    messages: {
      saved: 'Uzņēmuma dati saglabāti',
      failed: 'Neizdevās saglabāt uzņēmuma datus',
      loadFailed: 'Neizdevās ielādēt uzņēmuma datus',
    },
    detail: {
      backToList: 'Atpakaļ uz sarakstu',
      branchOf: 'Filiāle: {{name}}',
      webSite: 'Mājaslapa',
      logo: 'Logotips',
      noLogo: 'Nav logotipa',
    },
  },
  en: {
    title: 'Workplaces',
    search: 'Search by name or registration number',
    empty: 'No workplaces found',
    columns: {
      name: 'Name',
      regNo: 'Reg. no.',
      address: 'Address',
      subscription: 'Plan',
      planEnd: 'Plan end',
      userCount: 'Users',
      activeInterns: 'Active interns',
      branch: 'Branch',
      actions: 'Actions',
    },
    plans: {
      Business: 'Business',
      Free: 'Free',
      None: 'None',
    },
    actions: {
      edit: 'Edit',
    },
    edit: {
      title: 'Edit company',
      save: 'Save',
    },
    fields: {
      isPrivatePerson: 'Private person',
      name: 'Name',
      firstName: 'First name',
      lastname: 'Last name',
      email: 'Email',
      phone: 'Phone',
      webSite: 'Web page (optional)',
      address: 'Address',
      regNo: 'Registration number',
      vatNo: 'VAT number',
    },
    validation: {
      required: 'Field not filled',
      email: 'Invalid email',
    },
    messages: {
      saved: 'Company data saved',
      failed: 'Failed to save the company data',
      loadFailed: 'Failed to load the company data',
    },
    detail: {
      backToList: 'Back to the list',
      branchOf: 'Branch of {{name}}',
      webSite: 'Web page',
      logo: 'Logo',
      noLogo: 'No logo',
    },
  },
}
